import script from "./heade.vue?vue&type=script&setup=true&lang=js"
export * from "./heade.vue?vue&type=script&setup=true&lang=js"

import "./heade.vue?vue&type=style&index=0&id=57414940&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57414940"]])

export default __exports__